<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">

                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"
                            class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">

                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.title') }}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]"
                                                :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.description') }}</label>
                                            <input type="text" class="form-control rounded"
                                                name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __('forms.Question.sorting') }}</label> 
                                            <input type="number"
                                                class="form-control rounded" name="questionBase[sorting]"
                                                :value="this.sorting">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[allow_not_evaluable_languages]" type="checkbox"
                                                class="custom-control-input"
                                                id="questionSettings[allow_not_evaluable_languages]" value="1"
                                                v-model="allow_not_evaluable_languages" />
                                            <label class="custom-control-label"
                                                for="questionSettings[allow_not_evaluable_languages]">
                                                Mostra livello "Non Valutabile"
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.EvaluationChart.questions.questions_setting.question40.selectAssignement")}}</label>
                                            <select v-model="type_assignement"
                                                name="questionSettings[type_assignement]" class="form-control rounded"
                                                required>
                                                <option v-for="(name, key) in possible_assignement"
                                                    :value="key" v-bind:key="key">
                                                    {{ name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {

        props: {
            can_write: {
                type: Boolean,
                required: true,
            }
        },
        data() {
            return {
                //default
                title: "Comment",
                active: false,
                action: "",
                name: "",
                type: "textarea",
                description: "",
                sorting: -1,
                editing: true,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                languages: ['it', 'en', 'ch', 'de'],
                allow_not_evaluable_languages: false,
                possible_assignement: {},
                type_assignement: {}
            }
        },
        methods: {
            toggle(action, item_id, editing, attributes) {
                this.active = true;
                this.action = action;
                this.editing = editing;
                this.lang = attributes.lang;
                let dataRoute = decodeURI(attributes.dataRoute);
                if (dataRoute !== undefined) {
                    if (dataRoute.indexOf("[id]") > 0) {
                        dataRoute = dataRoute.replace("[id]", item_id);

                    }
                    axios.get(dataRoute)
                        .then((response) => {
                            this.name = response.data.base.name;
                            this.description = response.data.base.description;
                            this.sorting = response.data.base.sorting;
                            this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base
                                .enable);
                            this.allow_not_evaluable_languages = response.data.question_configuration.allow_not_evaluable_languages;
                            this.possible_assignement = response.data.possible_assignement;
                            this.type_assignement = response.data.question_configuration.type_assignement
                        });
                }
            }

        }

    }
</script>
